
/* eslint-disable */

export const CaptchaId = "6d915ba6e6b21601b2bb0a2a11ffe6a6";
/**
 * 初始化适应性验证
 */
 export function initGeetest(config = {}, domId, callback) {
    initGeetest4(
      {
        captchaId: CaptchaId,
        product: "float",
        ...config
      },
      function(captchaObj) {
        console.log(captchaObj);
        captchaObj.appendTo("#" + domId); //将验证按钮插入到宿主页面中captchaBox元素内
        captchaObj
          .onReady(function() {
            callback &&
              callback({
                type: "ready",
                captchaObj
              });
            console.log("[ready]", captchaObj);
            //your code
          })
          .onSuccess(function(e) {
            var result = captchaObj.getValidate();
            callback &&
              callback({
                type: "success",
                result
              });
            console.log("[success]", result);
            //your code
          })
          .onError(function(e) {
            //your code
            console.log("[error]", e);
          });
      }
    );
  }